import { Dropdown, message } from "antd";
import {
  useLazyDownloadAccountingStatementTitlesQuery,
  useLazyGetAccountingStatementDocumentUrlQuery
} from "redux/api/reconciliationsApiSlice";
import useFileDownloader from "../../../hooks/useFileDownloader";
import { AccountingStatement, JOB_STATUS } from "../../../types/reconciliation";
import { DownloadOutlined } from "@ant-design/icons";
import { DropdownButtonProps } from "antd/lib/dropdown";

export const DownloadAccountingStatementDocumentsButton = ({ accountingStatement, ...buttonProps }: {
  accountingStatement: AccountingStatement
} & DropdownButtonProps) => {
  const { downloadFile } = useFileDownloader();

  const [download, { isLoading: isDownloadingTitles }] = useLazyDownloadAccountingStatementTitlesQuery();
  const [getUrl, { isLoading: isLoadingDocument }] = useLazyGetAccountingStatementDocumentUrlQuery();

  return (
    <Dropdown.Button
      loading={isLoadingDocument || isDownloadingTitles}
      type={"text"}
      icon={<DownloadOutlined />}
      menu={{
        items: [
          {
            key: "accounting_statement_titles",
            label: "Scarica Foglio Cassa Standard",
            disabled: accountingStatement.rore_job_status !== JOB_STATUS.DONE
          },
          { key: "accounting_statement_document", label: "Scarica Estratto Conto" }
        ], onClick: (e) => {
          switch (e.key) {
            case "accounting_statement_document":
              getUrl(accountingStatement.uuid)
                .unwrap()
                .then(res => {
                  downloadFile(res.url);
                })
                .catch((err) => {
                  console.error("could not download statement titles due to an error: ", err);
                  message.error("Errore nel download del file");
                });
              break;

            case "accounting_statement_titles":
              download({ uuid: accountingStatement.uuid }).unwrap().catch((err) => {
                console.error("could not download statement titles due to an error: ", err);
                message.error("Errore nel download del file");
              });
              break;

          }
        }
      }}
      {...buttonProps}
    />
  );
};